(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observador = null;

  function initReveals(raiz) {
    var els = (raiz || document).querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (reducido || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('mt-visible'); observador.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { observador.observe(el); });
  }

  function initHero() {
    document.querySelectorAll('.mt-hero').forEach(function (h) {
      requestAnimationFrame(function () { h.classList.add('mt-listo'); });
    });
  }

  function initComparador() {
    document.querySelectorAll('.mt-ad__comp').forEach(function (c) {
      if (c.dataset.mtInit) return; c.dataset.mtInit = '1';
      var boton = c.querySelector('.mt-ad__boton');
      var pos = 50, arrastrando = false;
      function poner(p) { pos = Math.max(0, Math.min(100, p)); c.style.setProperty('--mt-pos', pos + '%'); if (boton) boton.setAttribute('aria-valuenow', Math.round(pos)); }
      function desdeEvento(ev) { var r = c.getBoundingClientRect(); var x = (ev.touches ? ev.touches[0].clientX : ev.clientX); poner((x - r.left) / r.width * 100); }
      c.addEventListener('pointerdown', function (ev) { arrastrando = true; desdeEvento(ev); try { c.setPointerCapture(ev.pointerId); } catch (e) {} });
      c.addEventListener('pointermove', function (ev) { if (arrastrando) desdeEvento(ev); });
      c.addEventListener('pointerup', function () { arrastrando = false; });
      c.addEventListener('pointercancel', function () { arrastrando = false; });
      if (boton) boton.addEventListener('keydown', function (ev) {
        if (ev.key === 'ArrowLeft') { poner(pos - 5); ev.preventDefault(); }
        if (ev.key === 'ArrowRight') { poner(pos + 5); ev.preventDefault(); }
      });
      poner(parseFloat(c.dataset.inicio || 50));
    });
  }

  function initHotspots() {
    document.querySelectorAll('.mt-hs__escena').forEach(function (esc) {
      if (esc.dataset.mtInit) return; esc.dataset.mtInit = '1';
      var items = esc.querySelectorAll('.mt-hs__item');
      items.forEach(function (it) {
        var b = it.querySelector('.mt-hs__punto');
        b.addEventListener('click', function (ev) {
          ev.stopPropagation();
          var activo = it.classList.contains('mt-activo');
          items.forEach(function (o) { o.classList.remove('mt-activo'); o.querySelector('.mt-hs__punto').setAttribute('aria-expanded', 'false'); });
          if (!activo) { it.classList.add('mt-activo'); b.setAttribute('aria-expanded', 'true'); }
        });
      });
      document.addEventListener('click', function () { items.forEach(function (o) { o.classList.remove('mt-activo'); }); });
    });
  }

  function initProducto() {
    document.querySelectorAll('[data-mt-producto]').forEach(function (raiz) {
      if (raiz.dataset.mtInit) return; raiz.dataset.mtInit = '1';
      var principal = raiz.querySelector('.mt-prod__principal img');
      raiz.querySelectorAll('.mt-prod__minis button').forEach(function (b) {
        b.addEventListener('click', function () {
          raiz.querySelectorAll('.mt-prod__minis button').forEach(function (o) { o.classList.remove('mt-activo'); });
          b.classList.add('mt-activo');
          if (principal) { principal.src = b.dataset.src; principal.srcset = ''; }
        });
      });
      var datos = raiz.querySelector('script[data-mt-variantes]');
      if (!datos) return;
      var variantes = JSON.parse(datos.textContent);
      var form = raiz.querySelector('form[action*="/cart/add"]');
      var inputId = form && form.querySelector('input[name="id"]');
      var boton = raiz.querySelector('.mt-prod__comprar');
      var precio = raiz.querySelector('.mt-actual');
      var tachado = raiz.querySelector('.mt-prod__precio s');
      var formato = raiz.dataset.formato || '{{amount}}';
      function dinero(c) {
        var v = (c / 100).toFixed(2);
        return formato.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ',')).replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(c / 100));
      }
      function actualizar() {
        var sel = [];
        raiz.querySelectorAll('.mt-prod__opcion').forEach(function (op) {
          var ch = op.querySelector('input:checked'); sel.push(ch ? ch.value : null);
        });
        var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
        if (!v) return;
        if (inputId) inputId.value = v.id;
        if (precio) precio.textContent = dinero(v.price);
        if (tachado) { if (v.compare_at_price && v.compare_at_price > v.price) { tachado.textContent = dinero(v.compare_at_price); tachado.hidden = false; } else { tachado.hidden = true; } }
        if (boton) { boton.disabled = !v.available; boton.querySelector('span').textContent = v.available ? boton.dataset.texto : boton.dataset.agotado; }
        if (v.featured_image && principal) { principal.src = v.featured_image.src; principal.srcset = ''; }
      }
      raiz.querySelectorAll('.mt-prod__opcion input').forEach(function (i) { i.addEventListener('change', actualizar); });
    });
  }

  function initCarrusel() {
    document.querySelectorAll('[data-mt-carrusel]').forEach(function (raiz) {
      if (raiz.dataset.mtInit) return; raiz.dataset.mtInit = '1';
      var pista = raiz.querySelector('.mt-op__pista');
      if (!pista) return;
      function mover(dir) {
        var tarjetas = pista.querySelectorAll('.mt-op__tarjeta');
        if (tarjetas.length < 2) return;
        var base = tarjetas[0].offsetLeft;
        var fin = pista.scrollWidth - pista.clientWidth;
        var actual = 0;
        tarjetas.forEach(function (t, i) { if (Math.abs(t.offsetLeft - base - pista.scrollLeft) < Math.abs(tarjetas[actual].offsetLeft - base - pista.scrollLeft)) actual = i; });
        var destino;
        if (dir > 0 && pista.scrollLeft >= fin - 4) destino = 0;
        else if (dir < 0 && pista.scrollLeft <= 4) destino = fin;
        else destino = Math.max(0, Math.min(fin, tarjetas[Math.max(0, Math.min(tarjetas.length - 1, actual + dir))].offsetLeft - base));
        pista.scrollTo({ left: destino, behavior: reducido ? 'auto' : 'smooth' });
      }
      var prev = raiz.querySelector('.mt-op__flecha--prev');
      var next = raiz.querySelector('.mt-op__flecha--next');
      if (prev) prev.addEventListener('click', function () { mover(-1); });
      if (next) next.addEventListener('click', function () { mover(1); });
      var seg = parseFloat(raiz.dataset.segundos || 0);
      if (!seg || reducido) return;
      var pausa = false, visible = false;
      raiz.addEventListener('mouseenter', function () { pausa = true; });
      raiz.addEventListener('mouseleave', function () { pausa = false; });
      raiz.addEventListener('focusin', function () { pausa = true; });
      raiz.addEventListener('focusout', function () { pausa = false; });
      pista.addEventListener('touchstart', function () { pausa = true; }, { passive: true });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(raiz);
      setInterval(function () { if (!pausa && visible && !document.hidden) mover(1); }, seg * 1000);
    });
  }

  function initTodo() { initReveals(); initHero(); initComparador(); initHotspots(); initProducto(); initCarrusel(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo);
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
